import ArrayUtils from '../collections/ArrayUtils';
import DefaultComparer from './DefaultComparer';
import DefaultEqualityComparer from './DefaultEqualityComparer';
import ObjectCloneOptions from './ObjectCloneOptions';
import ObjectEqualOptions from './ObjectEqualOptions';
export default class ObjectUtils {
    static compare(obj1, obj2) {
        return DefaultComparer.compare(obj1, obj2);
    }
    ;
    static convert(obj, valueSelector) {
        const result = {};
        Object.keys(obj).forEach(key => {
            result[key] = valueSelector(obj[key], key);
        });
        return result;
    }
    ;
    static deepClone(source, options) {
        options = new ObjectCloneOptions(options);
        let result;
        if (source === undefined) {
            result = undefined;
        }
        else if (source === null) {
            result = null;
        }
        else if (ObjectUtils.isFunction(source.deepClone)) {
            result = source.deepClone();
        }
        else if (ObjectUtils.isFunction(source.clone)) {
            result = source.clone();
        }
        else if (source instanceof Date) {
            result = new Date(source);
        }
        else if (Array.isArray(source)) {
            result = [];
            for (const value of source) {
                result.push(ObjectUtils.deepClone(value));
            }
        }
        else if (ObjectUtils.isObject(source)) {
            result = {};
            for (const key of Object.keys(source)) {
                if (key in options.excludeKeys) {
                    continue;
                }
                result[key] = ObjectUtils.deepClone(source[key]);
            }
        }
        else {
            result = source;
        }
        return result;
    }
    ;
    static deepEqual(obj1, obj2, options) {
        options = new ObjectEqualOptions(options);
        if (ObjectUtils.equal(obj1, obj2)) {
            return true;
        }
        else if (Array.isArray(obj1) && Array.isArray(obj2)) {
            return ArrayUtils.equal(obj1, obj2, ObjectUtils.deepEqual);
        }
        else if (ObjectUtils.isObject(obj1) && ObjectUtils.isObject(obj2)) {
            if (ObjectUtils.keyCount(obj1) !== ObjectUtils.keyCount(obj2)) {
                return false;
            }
            for (const key of Object.keys(obj1)) {
                if (key in options.excludeKeys) {
                    continue;
                }
                else if (!(key in obj2)) {
                    return false;
                }
                else if (!ObjectUtils.deepEqual(obj1[key], obj2[key])) {
                    return false;
                }
            }
            return true;
        }
        else if (ObjectUtils.isFunction(obj1) && ObjectUtils.isFunction(obj2) && options.excludeFunctions) {
            return true;
        }
        return false;
    }
    ;
    static equal(obj1, obj2) {
        return DefaultEqualityComparer.equal(obj1, obj2);
    }
    ;
    static filter(source, predicate) {
        const result = {};
        for (const key in source) {
            if (predicate(key, source[key])) {
                result[key] = source[key];
            }
        }
        return result;
    }
    ;
    static findKey(dictionary, predicate) {
        for (const key in dictionary) {
            if (predicate(dictionary[key])) {
                return key;
            }
        }
        return undefined;
    }
    ;
    static findTalue(dictionary, predicate) {
        for (const key in dictionary) {
            if (predicate(key, dictionary[key])) {
                return dictionary[key];
            }
        }
        return undefined;
    }
    ;
    static forEach(source, callback) {
        let index = 0;
        for (const key in source) {
            callback(key, source[key], index);
            index++;
        }
    }
    ;
    static isEmpty(obj) {
        return ObjectUtils.keyCount(obj) === 0;
    }
    ;
    static isFunction(obj) {
        return typeof obj === 'function';
    }
    ;
    static isGreaterThan(obj1, obj2) {
        return ObjectUtils.compare(obj1, obj2) > 0;
    }
    ;
    static isGreaterThanOrEqualTo(obj1, obj2) {
        return ObjectUtils.compare(obj1, obj2) >= 0;
    }
    ;
    static isIn(source, ...objects) {
        for (const object of objects) {
            if (source === object) {
                return true;
            }
        }
        return false;
    }
    ;
    static isLessThan(obj1, obj2) {
        return ObjectUtils.compare(obj1, obj2) < 0;
    }
    ;
    static isLessThanOrEqualTo(obj1, obj2) {
        return ObjectUtils.compare(obj1, obj2) <= 0;
    }
    ;
    static isObject(obj) {
        return (obj && typeof obj === 'object' && !Array.isArray(obj));
    }
    ;
    static keyCount(source) {
        return Object.keys(source).length;
    }
    ;
    static setIfAbsent(obj, key, value) {
        if (key in obj) {
            return false;
        }
        else {
            obj[key] = value;
            return true;
        }
    }
    ;
    static shallowClone(source, options) {
        options = new ObjectCloneOptions(options);
        let result;
        if (source === undefined) {
            result = undefined;
        }
        else if (source === null) {
            result = null;
        }
        else if (ObjectUtils.isFunction(source.shallowClone)) {
            result = source.shallowClone();
        }
        else if (ObjectUtils.isFunction(source.clone)) {
            result = source.clone();
        }
        else if (source instanceof Date) {
            result = new Date(source);
        }
        else if (Array.isArray(source)) {
            result = [];
            for (const value of source) {
                result.push(value);
            }
        }
        else if (ObjectUtils.isObject(source)) {
            result = {};
            for (const key of Object.keys(source)) {
                if (key in options.excludeKeys) {
                    continue;
                }
                result[key] = source[key];
            }
        }
        else {
            result = source;
        }
        return result;
    }
    ;
    static shallowEqual(obj1, obj2, options) {
        options = new ObjectEqualOptions(options);
        if (ObjectUtils.equal(obj1, obj2)) {
            return true;
        }
        else if (Array.isArray(obj1) && Array.isArray(obj2)) {
            return ArrayUtils.equal(obj1, obj2);
        }
        else if (ObjectUtils.isObject(obj1) && ObjectUtils.isObject(obj2)) {
            if (ObjectUtils.keyCount(obj1) !== ObjectUtils.keyCount(obj2)) {
                return false;
            }
            for (const key of Object.keys(obj1)) {
                if (key in options.excludeKeys) {
                    continue;
                }
                else if (!(key in obj2)) {
                    return false;
                }
                else if (!ObjectUtils.equal(obj1[key], obj2[key])) {
                    return false;
                }
            }
            return true;
        }
        else if (ObjectUtils.isFunction(obj1) && ObjectUtils.isFunction(obj2) && options.excludeFunctions) {
            return true;
        }
        return false;
    }
    ;
    static shallowMerge(target, source) {
        let target_ = target;
        if (source === undefined || source === null) {
            return target_;
        }
        else if (ObjectUtils.isObject(source) && ObjectUtils.isObject(target)) {
            target_ = Object(target);
            for (const key of Object.keys(source)) {
                target_[key] = source[key];
            }
        }
        else if (Array.isArray(source) && Array.isArray(target)) {
            target_.merge(source);
        }
        return target_;
    }
    ;
    static toArray(source, selector) {
        const result = [];
        let index = 0;
        for (const key in source) {
            if (selector) {
                result.push(selector(key, source[key], index));
            }
            else {
                result.push({ key: key, value: source[key] });
            }
            index++;
        }
        return result;
    }
    ;
}
//# sourceMappingURL=ObjectUtils.js.map